export default {"src":"/_next/static/media/thigh-strips.50fc6d20.svg","height":112,"width":112};